// redux/proctoringSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LogEvents } from '../../models/InterviewOnboardingModel';

export enum SUBMIT_LOCATION {
  NONE = '',
  CHAT_QUESTION = 'CHAT_QUESTION',
  AI_INTERVIEW_POPUP = 'AI_INTERVIEW_POPUP',
  ASSESSMENT_HEADER = 'ASSESSMENT_HEADER',
  ASSESSMENT_PAPER_HEADER = 'ASSESSMENT_PAPER_HEADER',
  ASSESSMENT_DIALOG = 'ASSESSMENT_DIALOG',
}
interface DeviationState {
  currentMinute: number;
  totalDeviationForMinute: number; // in milliseconds
  event_name: string; // This can be used to track the type of event causing deviation
  intervalEvent?: any; //
  shouldSubmitLog: boolean; // Indicates if the log should be submitted,
  shouldSubmitAssessment: boolean; // Indicates if the log should be submitted,
  submitAssessmentFrom: SUBMIT_LOCATION;
}

const initialState: DeviationState = {
  currentMinute: 1,
  totalDeviationForMinute: 0,
  event_name: LogEvents.EYE_VIEW_DEVIATION,
  intervalEvent: undefined, // This can be used for internal tracking
  shouldSubmitLog: false,
  shouldSubmitAssessment: false,
  submitAssessmentFrom: SUBMIT_LOCATION.NONE,
};

const proctoringSlice = createSlice({
  name: 'proctoring',
  initialState,
  reducers: {
    setCurrentMinute(state, action: PayloadAction<number>) {
      state.currentMinute = action.payload;
    },
    setTotalDeviationForMinute(
      state,
      action: PayloadAction<{
        totalDeviationForMinute: number;
        event_name: string;
      }>
    ) {
      state.totalDeviationForMinute = action.payload.totalDeviationForMinute;
      state.event_name = action.payload.event_name;
    },
    setIntervalEvent(state, action) {
      state.intervalEvent = action.payload.intervalEvent;
    },
    resetDeviation(state) {
      state.totalDeviationForMinute = 0;
    },
    setShouldSubmitLog(state, action) {
      state.shouldSubmitLog = action.payload;
    },
    setShouldSubmitAssessment(state, action) {
      state.shouldSubmitAssessment = action.payload;
    },
    setSubmitAssessmentFrom(state, action) {
      state.submitAssessmentFrom = action.payload;
    },
  },
});

export const {
  setCurrentMinute,
  setTotalDeviationForMinute,
  resetDeviation,
  setIntervalEvent,
  setShouldSubmitAssessment,
  setShouldSubmitLog,
  setSubmitAssessmentFrom,
} = proctoringSlice.actions;

export default proctoringSlice.reducer;
